<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-form>
      <v-card>
        <v-card-text class="tableBoxComponent">
          <v-row>
            <v-col cols="12" class="d-flex">
              <mrc_ess_switch v-model="levelcomponentslist.is_used" :true-value="1" v-if="$store.state.uuid"
                :false-value="0" :readonly="readonly" :true-text="$t('label_To_enable_the')"
                :false-text="$t('label_disable')"></mrc_ess_switch>
            </v-col>
            <v-col cols="12">
              <mrc_ess_multiText :label="$t('label_Group_name') + '*'" :isNational="judegNational('group_name')"
                :readonly="readonly" :error-messages="$errors('levelcomponentslist', 'group_name', [
                  ...nocharacter,
                  ...requiredRule,
                ])
                  " v-model="levelcomponentslist.group_name"></mrc_ess_multiText>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <mrc_ess_autoComplete :label="$t('label_company') + '*'" :readonly="readonly" orgView multiple
                v-model="levelcomponentslist.org_level_uuid" :error-messages="$errors('levelcomponentslist', 'org_level_uuid', requiredRule)
                  " :prompt_name="org_levels_sub">
              </mrc_ess_autoComplete>
            </v-col>
          </v-row>

          <!-- 表格 -->
          <v-data-table :headers="headers" :items="desserts" sort-by="calories" hide-default-footer>
            <template v-slot:no-data>
              <mrc_ess_noContent :no_data_text="$t('label_blank')" />
            </template>

            <template v-slot:item.job_grade_name="{ item }">
              {{ INT(item.job_grade_name) }}
            </template>
            <!-- 弹出框 -->
            <template v-slot:item.actions="{ item }">
              <!-- <v-icon @click="editItem(item)"
                      class="mr-4">
                mdi-pencil
              </v-icon>
              <v-icon :disabled="readonly"
                      @click="deleteItem(item)">
                mdi-delete
              </v-icon> -->
              <v-btn icon class="mr-2">
                <v-icon class="material-icons" @click="editItem(item)">
                  {{ readonly ? "visibility" : "mdi-pencil" }}
                </v-icon>
              </v-btn>
              <v-btn icon v-if="!readonly">
                <v-icon class="material-icons" @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <!-- <v-btn color="primary"
                     @click="initialize">Reset</v-btn> -->
            </template>
            <template v-slot:footer>
              <v-divider></v-divider>
              <mrc_ess_textAddBtn :text="$t('label_A_new_level')" v-if="!readonly" :rounded="false"
                @click="editItem('add')" depressed></mrc_ess_textAddBtn>
            </template>
          </v-data-table>
        </v-card-text>
        <mrc_ess_submitBtn @success="success" v-if="!readonly" :loading="btnIsLoading" @cancel="cancel">
        </mrc_ess_submitBtn>
      </v-card>
      <!-- 通过v-if让每个弹窗独立 -->
      <mrc_ess_myDialog v-model="dialog" v-if="dialog" :title="$t('label_A_new_level')" @success="save" @cancel="close"
        :disabled="!readonly">
        <v-card-text class="pa-0">
          <v-row>
            <v-col cols="12">
              <mrc_ess_multiText v-model="editedItem.job_grade_name" :isNational="judegNational('job_grade_name')"
                :readonly="readonly" :error-messages="$errors('editedItem', 'job_grade_name', [
                  ...nocharacter,
                  ...requiredRule,
                ])
                  " :label="$t('label_The_name_of_the_hierarchy') + '*'"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12">
              <mrc_ess_multiText v-model="editedItem.remark" :isNational="judegNational('remark')" noRequired
                :error-messages="$errors('editedItem', 'remark', nocharacter)" :readonly="readonly"
                :label="$t('label_note')"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12" class="mb-4">
              <mrc_ess_NumInput v-model="editedItem.job_grade_class" :readonly="readonly"
                :label="$t('label_The_hierarchy') + '*'" :error-messages="$errors('editedItem', 'job_grade_class', [
                  ...between('0-999'),
                  ...requiredRule,
                ])
                  "></mrc_ess_NumInput>
            </v-col>
            <v-col cols="12">
              <mrc_ess_NumInput v-model="editedItem.sequence" :readonly="readonly" :error-messages="$errors('editedItem', 'sequence', [
                ...between('0-999'),
                ...requiredRule,
              ])
                " :label="$t('label_The_sorting') + '*'"></mrc_ess_NumInput>
            </v-col>
          </v-row>
        </v-card-text>
      </mrc_ess_myDialog>
    </v-form>
  </mrc_ess_skeleton_loader>
</template>

<style scoped>
.h1 {
  margin-top: 20px;
  margin-left: 20px;
  text-align: start;
  font-size: 22px;
  color: #0f46c1;
}

.f1 {
  font-size: 30px;
  color: #0f46c1;
}

.bt1 {
  display: inline-block;
  width: 25px;
  height: 25px;
  background-color: #ccc;
  line-height: 25px;
  text-align: center;
}

.sequenceinput {
  border-top: 1px black solid;
  border-bottom: 1px black solid;
  text-align: center;
}
</style>

<script>
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators"
import {
  get_postgradesdetail,
  get_postgrades_groupdetail,
  update_postgrades_group,
  add_postgrades,
  add_postgrades_group,
} from "@/service/api/postgrades.js"
export default {
  components: {},
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      skeletonloading: true,
      btnIsLoading: false,
      company_uuid: "", //当前公司uuid
      switch1: 1,
      levelcomponentslist: {
        org_level_uuid: "", //单位名称（参照）
        group_name: "", //组名
        mrbase_sys_job_post_grades: [
          {
            sequence: "", //排序
            job_grade_class: "", //级别
            job_grade_shortcode: "", //短编码
            job_grade_name: "", //等级名
            remark: "", //备注
          },
        ],
        is_used: 1, //是否启用0 否 1 是
      }, //
      dialog: false,
      deletePostmanagement: [], //删除岗位等级列表
      desserts: [],
      editedIndex: -1,
      editedItem: {
        job_grade_name: "",
        job_grade_class: 1,
        remark: "",
        sequence: 1,
      },
      defaultItem: {
        job_grade_name: "",
        job_grade_class: 1,
        remark: "",
        sequence: 1,
      },
    }
  },
  validations: {
    levelcomponentslist: {
      group_name: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
        required,
      },
      org_level_uuid: {
        required,
      },
    },
    editedItem: {
      job_grade_name: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
        required,
      },
      job_grade_class: {
        between: between(0, 999),
        required,
      },
      remark: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      sequence: {
        between: between(0, 999),
        required,
      },
    },
  },
  beforeDestroy() {
    this.$store.commit("set_group_name", "")
  },
  created() { },
  async mounted() {
    this.national("mrbase_sys_job_post_grades")
    if (this.$store.state.uuid) {
      this.initialize()
    } else {
    }
  },
  methods: {
    typedelmethods(oldarr, newarr, comparisonvalue) {
      //加typedel方法
      var result = [] //
      for (var i = 0; i < oldarr.length; i++) {
        var c_value = oldarr[i].comparisonvalue
        var isExist = false
        for (let j = 0; j < newarr.length; j++) {
          if (newarr[j].comparisonvalue == c_value) {
            isExist = true
            break
          }
        }
        if (!isExist) {
          result.push({ ...oldarr[i], "~type~": "del" })
        }
      }
      return result
    },
    async success() {
      //提交
      this.$v.levelcomponentslist.$touch()
      this.$v.$touch()
      if (this.$v.levelcomponentslist.$error) return
      this.btnIsLoading = true
      this.desserts.map((item) => {
        delete item.isTrusted
        return item
      })
      // Array.isArray(this.levelcomponentslist.org_level_uuid)
      //   ? (this.levelcomponentslist.org_level_uuid = this.levelcomponentslist.org_level_uuid.join())
      //   : ''
      if (this.$store.state.uuid) {
        this.levelcomponentslist.mrbase_sys_job_post_grades = [
          ...this.desserts,
          ...this.deletePost,
        ].map((item) => {
          delete item.created_by
          delete item.updated_utc_datetime
          delete item.updated_by
          delete item.created_utc_datetime
          delete item.job_grade_id
          item["~table~"] = "mrbase_sys_job_post_grades"
          return item
        })
        const res = await update_postgrades_group(this.levelcomponentslist)
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          })
          await this.initialize()
          this.$emit("changeReadonly")
        }
        this.btnIsLoading = false
      } else {
        this.levelcomponentslist.mrbase_sys_job_post_grades = this.desserts
        const res = await add_postgrades_group(this.levelcomponentslist)
        if (res.code == 200) {
          this.$router.push({
            name: "Post_level_management",
          })
        }
        this.btnIsLoading = false
      }
    },
    async cancel() {
      if (this.$store.state.uuid) {
        await this.initialize()
        this.$emit("changeReadonly")
      } else {
        //取消
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "Post_level_management",
            })
          })
          .catch((err) => { })
      }
    },
    async initialize() {
      this.skeletonloading = true
      const res = await get_postgrades_groupdetail({
        group_name: this.$store.state.group_name,
      })
      if (res.code == 200) {
        this.levelcomponentslist = res.data
        // String(this.levelcomponentslist.org_level_uuid).indexOf(',') != -1
        //   ? (this.levelcomponentslist.org_level_uuid = this.levelcomponentslist.org_level_uuid.split(
        //     ','
        //   ))
        //   : (this.levelcomponentslist.org_level_uuid = [
        //     this.levelcomponentslist.org_level_uuid,
        //   ])
        this.desserts = this.levelcomponentslist.mrbase_sys_job_post_grades
      } else {
        this.$router.push({
          name: "Post_level_management",
          params: {
            type: "del",
          },
        })
      }
      this.skeletonloading = false
    },
    editItem(item) {
      //传了item就是修改  没传就是添加
      this.$v.editedItem.$reset()
      if (item != "add") {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
      }
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item)
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then(() => {
        const dd = this.desserts.splice(index, 1)
        if (dd[0].uuid || dd[0].client_uuid)
          this.deletePostmanagement.push(dd[0])
      })
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save() {
      this.$v.editedItem.$touch()
      if (this.$v.editedItem.$error) return
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem)
      } else {
        this.desserts.push(this.editedItem)
      }
      this.close()
    },
  },
  computed: {
    org_levels_sub() {
      return {
        prompt_name: "org_levels_sub",
        org_level_uuid: this.$store.state.currentCompany,
        // prompt_name: "org_levels_manager_filter_company_code",
        // user_id: this.$store.state.userData.user_id,
        // org_level_code: this.$store.state.currentCompanyObj.org_level_code,
      }
    },
    unit() {
      let user_uuid = JSON.parse(this.$ls.get("userData")).uuid //单位高级参照
      return { prompt_name: "org_levels_manager_filter_company", user_uuid }
    },
    headers() {
      return [
        {
          text: this.$t("label_The_name_of_the_hierarchy"),
          align: "start",
          sortable: false,
          value: "job_grade_name",
        },
        {
          text: this.$t("label_The_hierarchy"),
          sortable: false,
          align: "start",
          value: "job_grade_class",
        },
        {
          text: this.$t("label_note"),
          sortable: false,
          value: "remark",
          align: "start",
        },
        {
          text: this.$t("label_The_sorting"),
          value: "sequence",
          align: "start",
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ]
    },
    deletePost() {
      //删除岗位等级列表
      if (this.deletePostmanagement.length > 0) {
        return this.deletePostmanagement.map((item) => {
          return { ...item, "~type~": "del" }
        })
      } else {
        return []
      }
    },
    companyName() {
      //部门..currentCompany.uUID
      return (this.company_uuid = JSON.parse(
        this.$ls.get("userData")
      ).currentCompany.uUID)
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item"
    },
  },
}
</script>

<style scoped>
.tableBoxComponent /deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 8px 16px;
}
</style>
